import * as Yup from 'yup';

export const userSchema = Yup.object().shape({
  name: Yup.string().default('').required('Campo obrigatório'),
  email: Yup.string().default('').required('Campo obrigatório'),
  password: Yup.string().default('').required('Campo obrigatório'),
  confirm_password: Yup
    .string()
    .default('')
    .oneOf([Yup.ref('password'), null], 'As senhas precisam ser iguais')
    .required('Campo obrigatório')
});
